import React, { useEffect, useState } from "react";
import CustomInput from "../../../Components/InputCompo/CustomInput";
import CustomSelection from "../../../Components/SelectionComp/CustomSelection";
import { ParagraphComp } from "../../../Components/ParagraphComp/ParagraphComp";
import HeaderCompo from "../../../Components/HeaderComp/HeaderCompo";
import ButtonComp from "../../../Components/ButtonComp/ButtonComp";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { InputCompo } from "../../../Components/InputCompo/InputCompo";
import * as Yup from "yup";
import { FieldArray, Form, Formik, useFormikContext } from "formik";
import { allCountries } from "../RegistrationDatas";
import CustomFileInput from "../../../Components/InputCompo/CustomFileInput";
import { m } from "framer-motion";
import { fadeIn } from "../../../Functions/GlobalAnimations";
import { enqueueSnackbar } from "notistack";
import {
  UndertakingGet,
  UndertakingPost,
  UndertakingSubQPost,
  editRegistration,
} from "../../../Store/auth/register";
import MultipleSelect from "../../../Components/SelectionComp/MultipleSelect";
import CustomTextarea from "../../../Components/textareaComp/CustomTextarea";
import Loading from "../../../Components/Loader/Loading";
import ModalComp from "../../../Components/ModalComp";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import CloseIcon from "@mui/icons-material/Close";
import AddCommentIcon from "@mui/icons-material/AddComment";
const Undertaking2 = ({ setSubTabs }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const application_no = localStorage.getItem("RegKey");
  const queryClient = useQueryClient(); // Access the query client
  const [selectedRows, setSelectedRows] = useState({});
  const [openPopup, setOpenPopup] = useState({});
  const [fIlledValues, setFIlledValues] = useState([]);
  const [governingBodyValues, setGoverningBodyValues] = useState([]);
  const [tempStoreValue, setTempStoreValue] = useState([]);
  const [programme, setProgramme] = useState("");
  const [emailErrors, setEmailErrors] = useState({});
  const gsnNoFromStorage = localStorage.getItem("gsn_no");
  const { isLoading: fieldLoading, data: questions } = useQuery({
    queryKey: "undertaking",
    queryFn: () => UndertakingGet(gsnNoFromStorage ? gsnNoFromStorage : ""),
    cacheTime: 1000 * 60 * 5,
    staleTime: 0, // Setting staleTime to 0 will make sure data is marked as stale immediately
  });
  if (!gsnNoFromStorage) {
    setSubTabs({ "Operations Planning & Management": true });
  }

  // validations for fields

  const modelSchema = Yup.object({
    normalFields: Yup.object(
      questions?.documents?.reduce((schema, fields) => {
        let fieldValidation = Yup.string();
        // if (fields.type.toLowerCase() !== "section") {

        // Check if the field has a dependent question with a condition
        if (
          fields.depend_question &&
          fields.condition &&
          fields?.type?.toLowerCase() !== "section"
        ) {
          fieldValidation = fieldValidation.test(
            "dependent-condition",
            `${fields.question} is required when the condition is met`,
            function (value) {
              const { parent } = this;
              const dependentValue = parent[fields.depend_question];

              // Evaluate the condition using evaluateCondition function
              const isConditionMet = evaluateCondition(
                dependentValue,
                fields.condition,
                fields.value
              );
              // If condition is true, apply required validation, otherwise allow optional
              return isConditionMet ? !!value : true;
            }
          );
        }
        if (fields.validation.toLowerCase() === "email") {
          fieldValidation = fieldValidation.test(
            "match-dependent",
            ` Re-enter your organisation's primary email address to 
  confirm it's correct. This must match the email entered above to ensure 
  successful registration`,
            function (value) {
              const { parent } = this;
              const dependentValue = parent[fields.depend_question];
              if (dependentValue) {
                return value === dependentValue;
              }
              return true;
            }
          );
        } else if (fields.type.toLowerCase() === "password") {
          fieldValidation = fieldValidation.test(
            "match-dependent",
            `Re-enter your password to confirm it matches the one you 
  created above. This ensures your password is set correctly`,
            function (value) {
              const { parent } = this;
              const dependentValue = parent[fields.depend_question];
              if (dependentValue) {
                return value === dependentValue;
              }
              return true;
            }
          );
        }

        // Apply different validation rules based on the field's validation type
        if (
          fields.validation.toLowerCase() === "email" &&
          !fields.depend_question
        ) {
          fieldValidation = fieldValidation.matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            "Invalid email address"
          );
        } else if (fields.validation.toLowerCase() === "pan") {
          fieldValidation = fieldValidation.matches(
            /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
            "Invalid PAN Number. It should be in the format: ABCDE1234F."
          );
        } else if (fields.validation.toLowerCase() === "pincode") {
          fieldValidation = fieldValidation.matches(
            /^\d{4}$|^\d{6}$/,
            "PIN code must be exactly 6 digits"
          );
        } else if (fields.validation.toLowerCase() === "areacode") {
          fieldValidation = fieldValidation.matches(
            /^(123|456|789)$/,
            "Incorrect area code"
          );
        } else if (fields.type.toLowerCase() === "multiselect dropdown") {
          fieldValidation = Yup.array();
        } else if (fields.validation.toLowerCase() === "website") {
          fieldValidation = fieldValidation.url("Please enter a valid URL");
        } else if (fields.validation.toLowerCase() === "mobile") {
          fieldValidation = fieldValidation.matches(
            /^(?:[0-9]{10}|[0-9]{7})$/,
            "Invalid contact number"
          );
        } else if (fields.type.toLowerCase() === "attach") {
          fieldValidation = Yup.object();
        } else if (fields.validation.toLowerCase() === "darpan") {
          fieldValidation = fieldValidation.test(
            "is-valid-darpan",
            " Darpan Id should be in the format: XX/1234/1234567",
            (value) =>
              value?.toUpperCase() === "NA" ||
              /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
          );
        } else if (
          fields.validation.toLowerCase() === "password" &&
          !fields.depend_question
        ) {
          fieldValidation = fieldValidation.min(
            8,
            "Password must be at least 8 characters long"
          );
        }

        // Mark field as required based on the `mandatory` flag if condition is not applicable
        if (
          !fields.depend_question &&
          fields.type.toLowerCase() !== "section" &&
          fields?.mandatory === 1
        ) {
          fieldValidation = fieldValidation.required(
            `${fields?.question} is required`
          );
        }

        // Assign validation schema for the field
        schema[fields?.question_no] = fieldValidation;
        return schema;
        // }
      }, {})
    ),
    ...questions?.documents?.reduce((sectionSchemas, fields) => {
      if (fields.type.toLowerCase() === "section") {
        sectionSchemas[fields.question] = Yup.array().of(
          Yup.object(
            fields.sub_questions.reduce((subSchema, subField) => {
              let subFieldValidation = Yup.string();

              if (subField.depend_question && subField.condition) {
                subFieldValidation = subFieldValidation.test(
                  "dependent-condition",
                  `${subField.question} is required when the condition is met`,
                  function (value) {
                    const { parent } = this;
                    const dependentValue = parent[subField.depend_question];

                    // Evaluate the condition using evaluateCondition function
                    const isConditionMet = evaluateCondition(
                      dependentValue,
                      subField.condition,
                      subField.value
                    );

                    // If condition is true, apply required validation, otherwise allow optional
                    return isConditionMet ? !!value : true;
                  }
                );
              }

              // Similar logic for sub-questions (optional)
              if (subField?.validation?.toLowerCase() === "email") {
                subFieldValidation = subFieldValidation.matches(
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  "Invalid email address"
                );
              } else if (subField.validation?.toLowerCase() === "pan") {
                subFieldValidation = subFieldValidation.matches(
                  /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                  "Invalid PAN Number. It should be in the format: ABCDE1234F."
                );
              } else if (subField?.validation?.toLowerCase() === "pincode") {
                subFieldValidation = subFieldValidation.matches(
                  /^\d{4}$|^\d{6}$/,
                  "PIN code must be exactly 6 digits"
                );
              } else if (subField.type.toLowerCase() === "attach") {
                subFieldValidation = Yup.object();
              } else if (
                subField.type.toLowerCase() === "multiselect dropdown"
              ) {
                subFieldValidation = Yup.array();
              } else if (subField?.validation?.toLowerCase() === "mobile") {
                subFieldValidation = subFieldValidation.matches(
                  /^(?:[0-9]{10}|[0-9]{7})$/,
                  "Invalid contact number"
                );
              }

              // Add email validation for governing body member email field
              if (subField.question_no === "SQ-00315") {
                console.log("Validating email for SQ-00315");

                subFieldValidation = subFieldValidation
                  .matches(
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    "Invalid email address"
                  )
                  .required("Email is required");
              }

              if (subField.mandatory === 1) {
                subFieldValidation = subFieldValidation.required(
                  `${subField.question} is required`
                );
              }

              subSchema[subField.question_no] = subFieldValidation;
              return subSchema;
            }, {})
          )
        );
      }
      return sectionSchemas;
    }, {}),
  });

  // formik for submission fields

  const handleCreateSuccess = () => {
    // setSubTabs({ "Sources of Funding": true })
    setOpenPopup({ popup: false });
    enqueueSnackbar("success!", { variant: "success" });
    queryClient.invalidateQueries(["undertaking"]);
  };

  const handleCreateError = (error) => {
    if (error?.response?.data.status_code >= 500) {
      enqueueSnackbar(error?.response?.data?.status_message, {
        variant: "error",
      });
    } else {
      enqueueSnackbar(error?.response?.data?.status_message || error?.message, {
        variant: "error",
      });
    }
  };

  const createFarmerMutationOptions = {
    onSuccess: handleCreateSuccess,
    onError: handleCreateError,
  };

  const {
    mutate: submitInitialReg,
    // data: regFinalData,
    isPending: mainRegistration,
  } = useMutation({
    mutationFn: UndertakingPost,
    ...createFarmerMutationOptions,
  });

  const attachFile = (e, setFieldValue) => {
    if (!e.target.files || e.target.files.length === 0) {
      setFieldValue(e.target.name, "");
      return; // Prevent further execution if no file is selected
    }
    const file = e.target.files[0];
    const name = e.target.name;
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        setFieldValue(name, {
          attach_file: base64String,
          file_name: file.name,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const evaluateCondition = (value1, condition, value2) => {
    if (Array.isArray(value1)) {
      return value1.includes(value2); // Check if array contains the required value
    }
    switch (condition) {
      case "==":
        return value1 == value2; // Using loose equality as per original suggestion
      case "===":
        return value1 === value2;
      case "!==":
        return value1 !== value2;
      case ">":
        return value1 > value2;
      case "<":
        return value1 < value2;
      case ">=":
        return value1 >= value2;
      case "<=":
        return value1 <= value2;
      default:
        return false;
    }
  };

  const createInitialValues = () => {
    const preparedData = fIlledValues?.[openPopup?.index];
    if (preparedData) {
      return questions?.documents?.reduce((values, field) => {
        if (field.type.toLowerCase() === "section") {
          // Use the question text as the key for section data in preparedData
          const sectionKey = field.question; // e.g., "Enter Information for three Financial Year"
          const sectionRows = (preparedData?.[sectionKey] || []).flat();
          values[field.question_no] = sectionRows.map((row) => {
            const rowObj = {};
            field.sub_questions.forEach((subQ) => {
              if (subQ.type?.toLowerCase() === "multiselect dropdown") {
                rowObj[subQ.question_no] =
                  row[subQ.question_no]?.split(",") || [];
              } else if (subQ.type?.toLowerCase() === "attach") {
                rowObj[subQ.question_no] = {
                  file_name: row[subQ.question_no]?.file_name,
                  attach_file: row?.upload_document,
                };
              } else {
                rowObj[subQ.question_no] = row[subQ.question_no] || "";
              }
            });
            return rowObj;
          });
        } else {
          values.normalFields = values.normalFields || {};
          if (field?.question_no) {
            if (field.type.toLowerCase() === "multiselect dropdown") {
              values.normalFields[field.question_no] =
                preparedData?.normalFields?.[field.question_no] || [];
            } else if (field?.type.toLowerCase() === "attach") {
              values.normalFields[field.question_no] = {
                file_name: field?.file_name,
                attach_file: field?.upload_document,
              };
            } else {
              values.normalFields[field.question_no] =
                preparedData?.normalFields?.[field.question_no] || ""; // Ensure default empty value
            }
          }
        }
        return values;
      }, {});
    } else {
      return questions?.documents?.reduce((values, field) => {
        values.normalFields = values.normalFields || {};
        values.normalFields[field?.question_no] = "";
        if (field.question_no === "UQ-00043") {
          // Initialize section array
          let tempData = []; // Initialize array to store multiple rows

          if (Array.isArray(questions?.undertaking?.governing_body_members)) {
            const groupedData = {}; // Object to store Name & Email pairs

            // Iterate through the array in steps of 2 (assuming Name and Email are consecutive)
            for (
              let i = 0;
              i < questions.undertaking.governing_body_members.length;
              i += 2
            ) {
              const nameEntry = questions.undertaking.governing_body_members[i];
              const emailEntry =
                questions.undertaking.governing_body_members[i + 1];

              // Ensure both entries belong to the same person
              if (
                nameEntry.depended_question_no === "SQ-00314" &&
                emailEntry.depended_question_no === "SQ-00315"
              ) {
                const row = {
                  "SQ-00314": nameEntry.answer, // Name field
                  "SQ-00315": emailEntry.answer, // Email field
                };
                tempData.push(row); // Add the row to the result array
              }
            }
          } else {
            console.error(
              "governing_body_members is not an array:",
              questions?.undertaking?.governing_body_members
            );
          }

          // Store the final array in values
          values[field.question_no] = tempData;

          console.log(tempData);
        } else if (field.type.toLowerCase() === "section") {
          if (field?.answer?.length > 0) {
            const tempData = [];
            field.answer.forEach((Row, index) => {
              Row.forEach((Field) => {
                console.log("Field", Field);

                if (!tempData[index]) tempData[index] = {}; // Ensure initialization
                tempData[index][Field?.question_no] = Field?.answer || ""; // Ensure default empty value
              });
            });
            values[field.question_no] = values[field.question_no] || tempData; // Ensure array initialization
          } else {
            values[field.question_no] = values[field.question_no] || [{}]; // Ensure array initialization
            values[field.question_no].forEach((row) => {
              field?.sub_questions?.forEach((subField) => {
                row[subField?.question_no] =
                  subField?.question === "Country Code" ? "+91 - India" : "";
              });
            });
          }
        }
        return values;
      }, {});
    }
  };

  //

  const toggleAllRows = (e, values, question_no) => {
    const isChecked = e.target.checked;
    setSelectedRows((prev) => ({
      ...prev,
      [question_no]: isChecked
        ? values?.[question_no]?.map((_, idx) => idx)
        : [],
    }));
  };

  const toggleRowSelection = (rowIndex, question_no) => {
    setSelectedRows((prev) => {
      const prevSelected = prev[question_no] || [];
      return {
        ...prev,
        [question_no]: prevSelected.includes(rowIndex)
          ? prevSelected.filter((i) => i !== rowIndex)
          : [...prevSelected, rowIndex],
      };
    });
  };

  const deleteSelectedRows = (remove, question) => {
    selectedRows?.[question].sort((a, b) => b - a); // Sort in descending order to avoid index shifting
    selectedRows?.[question].forEach((index) => remove(index));
    setSelectedRows([]); // Clear selection after deletion
  };

  const DisplayFormikValues = () => {
    const { values } = useFormikContext();

    // setProgramme(values?.['normalFields']?.['APQ-00080'])
    return null; // You can return JSX or null if you just want to log the values
  };

  useEffect(() => {
    if (questions?.docs_answers) {
      let tempFilled = [];
      questions?.docs_answers?.length > 0 &&
        questions?.docs_answers?.map((row, index) => {
          const allFields = row?.d_answers;

          allFields?.map((answers) => {
            if (
              answers?.type?.toLowerCase() === "section" &&
              answers?.answer?.length > 0
            ) {
              let sectionData = []; // Initialize sectionData outside the loop to accumulate all rows

              answers?.answer?.forEach((sectionRow) => {
                let rowObject = {}; // Initialize a new object for each sectionRow

                sectionRow?.forEach((secInsideArray) => {
                  // Add key-value pairs to the rowObject
                  rowObject[secInsideArray.question_no] =
                    secInsideArray?.answer;
                });

                // Push the fully constructed rowObject into sectionData
                sectionData.push(rowObject);
              });

              // Update tempFilled for the current question
              tempFilled[index] = {
                ...tempFilled[index],
                [answers.question]: sectionData, // Use the accumulated sectionData array
              };
            } else {
              if (answers?.type?.toLowerCase() === "multiselect dropdown") {
                tempFilled[index] = {
                  ...tempFilled[index],
                  normalFields: {
                    ...tempFilled[index]?.normalFields,
                    [answers.question_no]: answers?.answer
                      ? answers?.answer?.split(",")
                      : [],
                  },
                };
              } else {
                tempFilled[index] = {
                  ...tempFilled[index],
                  normalFields: {
                    ...tempFilled[index]?.normalFields,
                    [answers.question_no]: answers?.answer
                      ? answers?.answer
                      : "",
                  },
                };
              }
            }
          });

          //
        });
      setFIlledValues(tempFilled);
      console.log("tempFilled", tempFilled);
    }
  }, [questions?.docs_answers]);

  useEffect(() => {
    if (questions?.undertaking?.governing_body_members) {
      let tempFilled = [];
      questions?.undertaking?.governing_body_members?.length > 0 &&
        questions?.undertaking?.governing_body_members?.map((row, index) => {
          const allFields = row;

          tempFilled[0] = {
            ...tempFilled[0],
            [row.depended_question_no]: row?.answer ? row?.answer : "",
          };

          //
        });
      setGoverningBodyValues(tempFilled);
    }
  }, [questions?.undertaking?.governing_body_members]);

  const SubmitData = (values) => {
    let tempData = values?.["normalFields"];

    const FinalData = questions?.documents?.map((fields) => {
      if (fields?.type?.toLowerCase() === "attach") {
        return {
          question_no: fields?.question_no,
          attach_file: tempData?.[fields?.question_no]?.attach_file,
          file_name: tempData?.[fields?.question_no]?.file_name,
        };
      } else if (fields?.type.toLowerCase() === "number") {
        return {
          question_no: fields?.question_no,
          answer: `${tempData[fields?.question_no]}`,
        };
      } else if (fields?.type.toLowerCase() === "checkbox") {
        return {
          question_no: fields?.question_no,
          answer: `${tempData[fields?.question_no] ? "Y" : "N"}`,
        };
      } else if (
        fields?.type.toLowerCase() === "multiselect dropdown" &&
        tempData?.[fields?.question_no]
      ) {
        return {
          question_no: fields?.question_no,
          answer: `${tempData?.[fields?.question_no].map((ele) => {
            return ele;
          })}`,
        };
      } else {
        return {
          question_no: fields?.question_no,
          answer: tempData[fields?.question_no],
        };
      }
    });

    // const currentDate = new Date().toISOString().split('T')[0]
    const structuredData = {
      args: {
        gsn_no: gsnNoFromStorage,
        year: tempData?.["UQ-00067"],
        governing_body: tempData?.["UQ-00015"]
          ? `The organisation has a Governing Body and it is called ${tempData?.["UQ-00015"]}`
          : "",
        no_of_meeting: tempData?.["UQ-00018"]
          ? `Our Governing Board has at least ${tempData?.["UQ-00018"]} meetings in a financial year, suitably spaced (at least 3 months apart), with quorum as stipulated in our own Articles of Association/ Trust Deed/ Constitution/ Bye Laws`
          : "",
        fcra_registration: tempData?.["UQ-00042"]
          ? `Our organisation’s FCRA registration was Renewed on ${tempData?.["UQ-00042"]}`
          : "",
        undertaking_question_answers: FinalData,
      },
    };
    submitInitialReg(structuredData, {
      onSuccess: () => {
        // Only submit the table data after the initial registration succeeds
        questions?.documents?.map((ele) => {
          console.log(
            "Onsucess values",
            ele.question,
            values?.[ele.question_no]
          );
          if (ele?.type?.toLowerCase() === "section") {
            submitTable(
              gsnNoFromStorage,
              { [ele.question]: values?.[ele.question_no] },
              tempData
            );
          }
        });
      },
      onError: (error) => {
        console.error("Error in initial registration submission:", error);
      },
    });
  };

  const multiSelectedValues = (name, question_no, value, setFieldValue) => {
    setFieldValue(name, value);
  };

  const submitTable = async (gsn, data, normalData) => {
    console.log("normalData>>>", normalData);
    if (gsn) {
      try {
        const sections = questions?.documents?.filter(
          (ele) => ele.type.toLowerCase() === "section"
        );
        // Use forEach to iterate since we're not using the return value
        await Promise.all(
          sections.map(async (Sec) => {
            let passedValues = {
              args: {
                gsn_num: gsn,
                year: normalData?.["UQ-00067"],
                main_question_no: Sec?.question_no,
                question_answers: [],
              },
            };
            if (Sec?.question && data?.[Sec?.question]) {
              data?.[Sec?.question].forEach((ele, index) => {
                let tempQuestion_answers = [];
                Sec.sub_questions.forEach((Sub) => {
                  if (
                    (Sub.type.toLowerCase() === "attach" &&
                      ele[Sub.question_no]) ||
                    (Sub.type.toLowerCase() === "attach" &&
                      ele[Sub.question_no] === "")
                  ) {
                    tempQuestion_answers.push({
                      question_no: Sub.question_no,
                      file_name: ele[Sub.question_no]?.file_name || "",
                      attach_file: ele[Sub.question_no]?.attach_file || "",
                    });
                  } else if (Sub.type.toLowerCase() === "checkbox") {
                    tempQuestion_answers.push({
                      question_no: Sub.question_no,
                      answer: ele[Sub.question_no] === "1" ? "1" : "0", // Ensure correct format
                    });
                  } else if (
                    Sub.type.toLowerCase() === "multiselect dropdown" &&
                    ele[Sub.question_no]
                  ) {
                    tempQuestion_answers.push({
                      question_no: Sub.question_no,
                      answer: `${ele[Sub.question_no].map((ele) => {
                        return ele;
                      })}`,
                    });
                  } else {
                    tempQuestion_answers.push({
                      question_no: Sub.question_no,
                      answer: ele[Sub.question_no],
                    });
                  }
                  passedValues.args.question_answers[index] =
                    tempQuestion_answers;
                });
              });
            }

            // Ensure the API call only happens if there are question answers
            if (
              passedValues.args.question_answers.length > 0 &&
              passedValues.args.question_answers.some((ele) =>
                ele.some((Qn) => Qn.answer || Qn.attach_file)
              )
            ) {
              await submitSubReg(passedValues); // Await the mutation function
            }
          })
        );
      } catch (error) {}
    }
  };

  const {
    mutateAsync: submitSubReg, // Use mutateAsync to work with async/await
    isPending: subLoading,
  } = useMutation({
    mutationFn: UndertakingSubQPost,
    ...createFarmerMutationOptions,
  });

  // loading questions

  // popup Fields managing

  const handleOpenPopup = (index) => {
    if (index === 0 || index > 0) {
      setOpenPopup({ popup: true, index: index });
    } else {
      if (fIlledValues?.length === 0) {
        setOpenPopup({ popup: true, index: 0 });
      } else {
        setOpenPopup({ popup: true, index: fIlledValues?.length + 1 });
      }
    }
  };
  const handleClosePopup = () => {
    setOpenPopup({ popup: false });
  };

  const OpenModal = (
    name,
    data,
    values,
    type,
    question,
    index,
    sub_question_num,
    subQuestion
  ) => {
    setIsModalOpen({
      [name]: true,
      data,
      values,
      type: type,
      index: index,
      question: question,
      sub_question_num: sub_question_num,
      subQuestion,
    });
  };

  const CloseModal = () => {
    if (!editLoading) {
      setIsModalOpen("");
    }
  };

  const updateValues = async (values) => {
    try {
      const currentDate = await new Date();
      let structuredData = "";
      const year =
        (questions?.docs_answers?.length > 0 &&
          questions?.docs_answers?.[openPopup?.index]?.d_answers?.find(
            (doc) => doc?.question_no === "UQ-00067"
          )?.answer) ||
        "";
      if (isModalOpen?.type?.toLowerCase() === "section") {
        const PreviousData = Array.isArray(
          questions?.docs_answers?.[openPopup?.index]?.d_answers?.find(
            (doc) => doc?.question === isModalOpen?.question
          )?.answer
        )
          ? questions?.docs_answers?.[openPopup?.index]?.d_answers
              ?.find((doc) => doc?.question === isModalOpen?.question)
              ?.answer?.[isModalOpen?.index].find(
                (ans) => ans.question_no === isModalOpen?.data.question_no
              )
          : "";
        structuredData = {
          args: {
            gsn_number: gsnNoFromStorage,
            date_and_time: formatDateTime(currentDate),
            gsi_id: application_no,
            question_id: isModalOpen?.sub_question_num,
            subquestion_id: isModalOpen?.data?.question_no,
            subquestion_previous_answer: PreviousData?.answer || "",
            subquestion_edited_answer:
              isModalOpen?.data?.type?.toLowerCase() === "multiselect dropdown"
                ? `${values?.[isModalOpen?.data?.question_no].map((ele) => {
                    return ele;
                  })}`
                : values?.[isModalOpen?.data?.question_no],
            subquestion_text: isModalOpen?.data?.question,
            question_text: isModalOpen?.subQuestion,
            section_name: "Undertaking",
            financial_year: year,
          },
        };
      } else {
        structuredData = await {
          args: {
            gsn_number: gsnNoFromStorage,
            date_and_time: formatDateTime(currentDate),
            gsi_id: application_no,
            question_id: isModalOpen?.data?.question_no,
            question_text: isModalOpen?.data?.question,
            previous_answer:
              values?.normalFields?.[isModalOpen?.data?.question_no] ||
              (questions?.docs_answers?.length > 0 &&
                questions?.docs_answers?.[openPopup?.index]?.d_answers?.find(
                  (doc) => doc?.question_no === isModalOpen?.data?.question_no
                )?.answer) ||
              "",
            edited_answer:
              isModalOpen?.data?.type?.toLowerCase() === "multiselect dropdown"
                ? `${values?.[isModalOpen?.data?.question_no].map((ele) => {
                    return ele;
                  })}`
                : values?.[isModalOpen?.data?.question_no],
            section_name: "Undertaking",
            financial_year: year,
          },
        };
      }
      console.log("structuredData>>>>", structuredData);

      await editData(structuredData);
    } catch (error) {}
  };
  const formatDateTime = (isoString) => {
    const date = new Date(isoString);

    // Extract YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
    const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits

    // Extract HH:MM:SS in 24-hour format
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
  const editModalSchema = Yup.object().shape({
    [isModalOpen?.data?.question_no]: (() => {
      let validation = Yup.string();

      // Check if isModalOpen?.data is defined
      if (!isModalOpen?.data) return validation;

      const fieldType = isModalOpen.data.type?.toLowerCase();
      const fieldValidation = isModalOpen.data.validation?.toLowerCase();

      // Apply validation based on `validation` property
      if (fieldValidation === "email" && !isModalOpen.data?.depend_question) {
        validation = validation.matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Invalid email address"
        );
      } else if (fieldValidation === "pan") {
        validation = validation.matches(
          /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
          "Invalid PAN Number. Format: ABCDE1234F."
        );
      } else if (fieldValidation === "pincode") {
        validation = validation.matches(
          /^\d{4}$|^\d{6}$/,
          "PIN code must be exactly 4 or 6 digits"
        );
      } else if (fieldValidation === "mobile") {
        validation = validation.matches(
          /^(?:[0-9]{10}|[0-9]{7})$/,
          "Invalid contact number"
        );
      } else if (fieldValidation === "website") {
        validation = validation.url("Please enter a valid URL");
      } else if (fieldValidation === "darpan") {
        validation = validation.test(
          "is-valid-darpan",
          "Darpan ID should be in the format: XX/1234/1234567",
          (value) =>
            value?.toUpperCase() === "NA" ||
            /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
        );
      } else if (
        fieldValidation === "password" &&
        !isModalOpen.data?.depend_question
      ) {
        validation = validation.min(
          8,
          "Password must be at least 8 characters long"
        );
      } else if (fieldType === "multiselect dropdown") {
        validation = Yup.array().of(Yup.string());
      } else if (fieldType === "attach") {
        validation = Yup.object();
      }

      // Apply 'required' validation if `mandatory` is 1
      if (isModalOpen.data.mandatory === 1) {
        validation = validation.required(
          `${isModalOpen.data.question} is required`
        );
      }

      return validation;
    })(),
  });

  const modalMultiSelectedValues = (name, values, setModalFieldValue) => {
    setModalFieldValue(name, values);
  };

  const hasAnswerForQuestion = (Fields, subQ) => {
    // Check if there are any answers in docs_answers
    const hasAnyAnswer =
      questions?.docs_answers?.[openPopup?.index]?.d_answers?.length > 0 &&
      questions?.docs_answers?.[openPopup?.index]?.d_answers?.some(
        (doc) => doc?.answer
      );

    // Find the specific document matching Fields.question
    const doc = questions?.docs_answers?.[openPopup?.index]?.d_answers?.find(
      (doc) => doc?.question === Fields?.question
    );

    // Check if there's at least one non-empty answer for the specific document
    const isAnyAnswerFilled =
      (doc?.answer?.length > 0 &&
        doc?.answer?.some((ele) => ele.some((dt) => dt?.answer))) ||
      false;

    return isAnyAnswerFilled || hasAnyAnswer;
  };

  const { mutate: editData, isPending: editLoading } = useMutation({
    mutationFn: editRegistration,
    ...createFarmerMutationOptions,
    onMutate: async () => {
      // Cancel the current query before mutating
      // await queryClient.cancelQueries(['Questions', application_no]);
    },
    onSuccess: () => {
      // Invalidate the query to refetch the latest data
      // queryClient.invalidateQueries(['Questions', application_no]);
    },
  });

  useEffect(() => {
    if (!editLoading) {
      setIsModalOpen("");
    }
  }, [editLoading]);

  if (fieldLoading || subLoading || mainRegistration) return <Loading />;

  return (
    <>
      <div className="flex flex-col">
        <div className="flex rounded-tl-[20px] rounded-tr-[20px] border-2 p-[10px] justify-end">
          <ButtonComp
            onClick={handleOpenPopup}
            className="rounded-full text-[white] bg-[#004878] px-[20px] py-[5px]"
          >
            Add
          </ButtonComp>
        </div>
        <table className="border-collapse border-2 w-[100%]">
          <thead className="border-b-2">
            <tr className="grid grid-cols-6">
              {questions?.documents?.slice(0, 5).map((fields) => (
                <th
                  className="p-[10px] w-[100%]"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 4, // Limits to 4 lines
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "clip",
                    wordWrap: "normal",
                    whiteSpace: "normal",
                    maxWidth: "100%",
                    lineHeight: "1.4em", // Adjust line height to fit exactly 4 lines
                    height: "6.5em",
                  }}
                >
                  {fields?.question}
                </th>
              ))}
              <th className="p-[10px] w-20%]">More View</th>
            </tr>
          </thead>
          <tbody>
            {fIlledValues?.map((FilledRows, index) => (
              <tr className="w-[100%] whitespace-nowrap grid grid-cols-6">
                {questions?.documents?.slice(0, 5).map((fields) => (
                  <th className="p-[10px] max-w-[20%]">
                    {FilledRows?.["normalFields"]?.[fields?.question_no]}
                  </th>
                ))}
                <th className="p-[10px]">
                  <ButtonComp
                    onClick={() => {
                      handleOpenPopup(index);
                    }}
                    text="View"
                    className="px-[10px] text-white py-[5px] rounded-full bg-[#004878]"
                  />
                </th>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ModalComp
        width="90%"
        modalIsOpen={openPopup?.popup}
        closeModal={handleClosePopup}
      >
        <div className="p-[20px]">
          <Formik
            initialValues={createInitialValues()}
            validationSchema={modelSchema}
            enableReinitialize={true}
            onSubmit={SubmitData}
          >
            {({
              values,
              errors,
              handleChange,
              touched,
              handleBlur,
              setFieldValue,
            }) => (
              <Form className="flex flex-col gap-[30px]" action="">
                <div className="flex flex-wrap gap-[30px] justify-between w-[100%]">
                  <div className="flex flex-col">
                    <HeaderCompo
                      className="text-2xl text-black whitespace-pre m-0 p-0"
                      text="Undertaking for GuideStar India Certification"
                      tagType="h3"
                    />
                    <HeaderCompo
                      className="text-2xl text-black whitespace-pre m-0 p-0"
                      text="Points of Undertaking"
                      tagType="h3"
                    />
                  </div>

                  {questions?.documents.map((Fields) => (
                    <>
                      {Fields?.paremeter ? (
                        <>
                          <div key={Fields.question_no} className="w-[100%]">
                            <HeaderCompo
                              className="text-2xl text-black"
                              text={Fields?.paremeter}
                              tagType="h3"
                            />
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {Fields.type.toLowerCase() === "text" ||
                      Fields.type.toLowerCase() === "number" ||
                      Fields.type.toLowerCase() === "float" ||
                      Fields.type.toLowerCase() === "date" ||
                      Fields.type.toLowerCase() === "password" ? (
                        <div
                          key={Fields.question_no}
                          className={`${
                            evaluateCondition(
                              values?.normalFields?.[Fields?.depend_question],
                              Fields.condition,
                              Fields.value
                            ) &&
                            Fields?.depend_question &&
                            values?.normalFields?.[Fields?.depend_question]
                              ? "block"
                              : Fields?.depend_question
                              ? "hidden"
                              : "block"
                          } ${
                            Fields?.question.toLowerCase() === "comment box"
                              ? "w-[100%]"
                              : " w-[48%]"
                          } flex gap-[10px] `}
                        >
                          <div className="w-[100%]">
                            <CustomInput
                              // disabled={
                              //   questions?.docs_answers?.length > 0 &&
                              //   questions?.docs_answers?.[
                              //     openPopup?.index
                              //   ]?.d_answers?.some((doc) => doc?.answer)
                              // }
                              required={Fields?.mandatory > 0 ? true : false}
                              type={
                                Fields.type.toLowerCase() === "float"
                                  ? "number"
                                  : Fields.type.toLowerCase()
                              }
                              name={`normalFields.${Fields.question_no}`}
                              label={Fields.question}
                              value={values?.normalFields?.[Fields.question_no]}
                              onChange={(e) => {
                                let value = e.target.value;
                                if (
                                  Fields.question_no === "GQ-00002" &&
                                  value.length > 200
                                ) {
                                  enqueueSnackbar(
                                    `${Fields?.question} cannot exceed 200 characters`,
                                    { variant: "warning" }
                                  );
                                  value = value.substring(0, 200); // Truncate to 200 characters
                                }
                                if (Fields.type.toLowerCase() === "float") {
                                  // Check if there is a decimal point and digits after it
                                  const decimalIndex = value.indexOf(".");
                                  if (decimalIndex !== -1) {
                                    const decimalPart = value.substring(
                                      decimalIndex + 1
                                    );
                                    // If more than two digits after decimal, show a warning and truncate the value
                                    if (decimalPart.length > 2) {
                                      enqueueSnackbar(
                                        `${Fields?.question} can only have up to 2 decimal places`,
                                        { variant: "warning" }
                                      );
                                      value = value.substring(
                                        0,
                                        decimalIndex + 3
                                      ); // Allow only 2 digits after decimal
                                    }
                                  }
                                }
                                e.target.value = value; // Update the input value
                                handleChange(e); // Continue with Formik's onChange
                              }}
                              allowFutureDates={
                                Fields.question_no === "GQ-00016" ? true : false
                              }
                            />
                            <ParagraphComp
                              className="text-[red] text-[10px] px-[8px] mt-1"
                              text={
                                values?.normalFields?.[Fields.question_no] &&
                                errors.normalFields?.[Fields.question_no]
                              }
                            />
                            <ParagraphComp
                              className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                              text={Fields.description}
                            />
                          </div>
                          {/* {questions?.docs_answers?.length > 0 &&
                            questions?.docs_answers?.[
                              openPopup?.index
                            ]?.d_answers?.some((doc) => doc?.answer) && (
                              <div className="flex gap-[10px] mt-[8px]">
                                <div
                                  onClick={() =>
                                    OpenModal("edit", Fields, values)
                                  }
                                  className=" cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                >
                                  <BorderColorIcon className="text-white" />
                                </div>
                                <div
                                  onClick={() =>
                                    OpenModal("comment", Fields, values)
                                  }
                                  className="bg-[#004878] h-fit rounded-full p-[8px]"
                                >
                                  <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                </div>
                              </div>
                            )} */}
                        </div>
                      ) : Fields.type.toLowerCase() === "dropdown" ? (
                        <div
                          key={Fields.question_no}
                          className={`${
                            evaluateCondition(
                              values?.normalFields?.[Fields?.depend_question],
                              Fields.condition,
                              Fields.value
                            ) &&
                            Fields?.depend_question &&
                            values?.normalFields?.[Fields?.depend_question]
                              ? "block"
                              : Fields?.depend_question
                              ? "hidden"
                              : "block"
                          } w-[100%] flex gap-[10px]`}
                        >
                          <div className="w-[100%]">
                            <CustomSelection
                              // disabled={
                              //   questions?.docs_answers?.length > 0 &&
                              //   questions?.docs_answers?.[
                              //     openPopup?.index
                              //   ]?.d_answers?.some((doc) => doc?.answer)
                              // }
                              required={Fields?.mandatory > 0 ? true : false}
                              options={Fields?.options}
                              value={values?.normalFields?.[Fields.question_no]}
                              onChange={handleChange}
                              name={`normalFields.${Fields.question_no}`}
                              label={Fields?.question}
                              noSort={true}
                            />
                            <ParagraphComp
                              className="text-[red] text-[10px] px-[8px] mt-1"
                              text={
                                values?.normalFields?.[Fields.question_no] &&
                                errors?.normalFields?.[Fields.question_no]
                              }
                            />
                            <ParagraphComp
                              className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                              text={Fields.description}
                            />{" "}
                          </div>
                          {/* {questions?.docs_answers?.length > 0 &&
                            questions?.docs_answers?.[
                              openPopup?.index
                            ]?.d_answers?.some((doc) => doc?.answer) && (
                              <div className="flex gap-[10px] mt-[8px]">
                                <div
                                  onClick={() =>
                                    OpenModal("edit", Fields, values)
                                  }
                                  className=" cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                >
                                  <BorderColorIcon className="text-white" />
                                </div>
                                <div
                                  onClick={() =>
                                    OpenModal("comment", Fields, values)
                                  }
                                  className="bg-[#004878] h-fit rounded-full p-[8px]"
                                >
                                  <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                </div>
                              </div>
                            )} */}
                        </div>
                      ) : Fields.type.toLowerCase() === "text area" ? (
                        <div
                          key={Fields.question_no}
                          className={`${
                            evaluateCondition(
                              values?.normalFields?.[Fields?.depend_question],
                              Fields.condition,
                              Fields.value
                            ) &&
                            Fields?.depend_question &&
                            values?.normalFields?.[Fields?.depend_question]
                              ? "block"
                              : Fields?.depend_question
                              ? "hidden"
                              : "block"
                          } ${
                            Fields?.question.toLowerCase() === "comment box"
                              ? "w-[100%]"
                              : " w-[100%]"
                          } flex gap-[10px] `}
                        >
                          <div className="w-[100%]">
                            <CustomTextarea
                              // disabled={
                              //   questions?.docs_answers?.length > 0 &&
                              //   questions?.docs_answers?.[
                              //     openPopup?.index
                              //   ]?.d_answers?.some((doc) => doc?.answer)
                              // }
                              required={Fields?.mandatory > 0 ? true : false}
                              type={Fields.type.toLowerCase()}
                              name={`normalFields.${Fields.question_no}`}
                              label={Fields.question}
                              value={values?.normalFields?.[Fields.question_no]}
                              onChange={handleChange}
                            />
                            <ParagraphComp
                              className="text-[red] text-[10px] px-[8px] mt-1"
                              text={
                                values?.normalFields?.[Fields.question_no] &&
                                errors.normalFields?.[Fields.question_no]
                              }
                            />
                            <ParagraphComp
                              className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                              text={Fields.description}
                            />
                          </div>
                          {/* {questions?.docs_answers?.length > 0 &&
                            questions?.docs_answers?.[
                              openPopup?.index
                            ]?.d_answers?.some((doc) => doc?.answer) && (
                              <div className="flex gap-[10px] mt-[8px]">
                                <div
                                  onClick={() =>
                                    OpenModal("edit", Fields, values)
                                  }
                                  className=" cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                >
                                  <BorderColorIcon className="text-white" />
                                </div>
                                <div
                                  onClick={() =>
                                    OpenModal("comment", Fields, values)
                                  }
                                  className="bg-[#004878] h-fit rounded-full p-[8px]"
                                >
                                  <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                </div>
                              </div>
                            )} */}
                        </div>
                      ) : Fields?.type.toLowerCase() ===
                        "multiselect dropdown" ? (
                        <div
                          key={Fields.question_no}
                          className={` ${
                            Fields?.description?.length > 150
                              ? "w-[100%]"
                              : " w-[100%]"
                          } flex gap-[10px] `}
                        >
                          <div className="w-[100%]">
                            <MultipleSelect
                              // disabled={
                              //   questions?.docs_answers?.length > 0 &&
                              //   questions?.docs_answers?.[
                              //     openPopup?.index
                              //   ]?.d_answers?.some((doc) => doc?.answer)
                              // }
                              required={Fields?.mandatory > 0 ? true : false}
                              options={
                                Fields?.question_no === "DRQ-00077"
                                  ? Fields?.options?.filter((ele) =>
                                      values?.["normalFields"]?.[
                                        "DRQ-00076"
                                      ]?.includes(ele.value)
                                    )
                                  : Fields?.options
                              }
                              maxSelect={
                                Fields.validation === "Select Upto 3" && 3
                              }
                              mappingKey={
                                Fields?.question_no !== "DRQ-00077"
                                  ? "option"
                                  : "option"
                              } // Pass mapping key if needed
                              // formik={formik} // Pass the formik instance
                              onValueChange={(name, values) =>
                                multiSelectedValues(
                                  name,
                                  Fields.question_no,
                                  values,
                                  setFieldValue
                                )
                              }
                              selectedValues={
                                values?.normalFields?.[Fields?.question_no] ||
                                []
                              }
                              name={`normalFields.${Fields?.question_no}`}
                              label={Fields?.question}
                              noSort={true}
                            />
                            <ParagraphComp
                              className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                              text={Fields.description}
                            />
                          </div>
                          {/* {questions?.docs_answers?.length > 0 &&
                            questions?.docs_answers?.[
                              openPopup?.index
                            ]?.d_answers?.some((doc) => doc?.answer) && (
                              <div className="flex gap-[10px] mt-[8px]">
                                <div
                                  onClick={() =>
                                    OpenModal("edit", Fields, values)
                                  }
                                  className=" cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                >
                                  <BorderColorIcon className="text-white" />
                                </div>
                                <div
                                  onClick={() =>
                                    OpenModal("comment", Fields, values)
                                  }
                                  className="bg-[#004878] h-fit rounded-full p-[8px]"
                                >
                                  <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                </div>
                              </div>
                            )} */}
                        </div>
                      ) : Fields.type.toLowerCase() === "attach" ? (
                        <div
                          key={Fields.question_no}
                          className={`${
                            evaluateCondition(
                              values?.normalFields?.[Fields?.depend_question],
                              Fields.condition,
                              Fields.value
                            ) &&
                            Fields?.depend_question &&
                            values?.normalFields?.[Fields?.depend_question]
                              ? "block"
                              : Fields?.depend_question
                              ? "hidden"
                              : "block"
                          } ${
                            Fields?.question?.length > 80
                              ? "w-[100%]"
                              : " w-[48%]"
                          } flex gap-[10px]`}
                        >
                          <div className="w-[100%]">
                            <>
                              <CustomFileInput
                                // disabled={
                                //   questions?.docs_answers?.length > 0 &&
                                //   questions?.docs_answers?.[
                                //     openPopup?.index
                                //   ]?.d_answers?.some((doc) => doc?.answer)
                                // }
                                required={Fields?.mandatory > 0 ? true : false}
                                onChange={(e) => attachFile(e, setFieldValue)}
                                value={
                                  values?.normalFields?.[Fields?.question_no]
                                    ?.file_name
                                }
                                file={
                                  values?.normalFields?.[Fields?.question_no]
                                    ?.attach_file
                                }
                                name={`normalFields.${Fields.question_no}`}
                                label={Fields?.question}
                              />
                              <ParagraphComp
                                className="text-[red] text-[10px] px-[8px] mt-1"
                                text={
                                  values?.normalFields?.[Fields.question_no] &&
                                  errors.normalFields?.[Fields.question_no]
                                }
                              />
                              <ParagraphComp
                                className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                                text={Fields.description}
                              />{" "}
                            </>
                          </div>
                          {/* {questions?.docs_answers?.length > 0 &&
                            questions?.docs_answers?.[
                              openPopup?.index
                            ]?.d_answers?.some((doc) => doc?.answer) && (
                              <div className="flex gap-[10px] mt-[8px]">
                                <div
                                  onClick={() =>
                                    OpenModal("comment", Fields, values)
                                  }
                                  className="bg-[#004878] h-fit rounded-full p-[8px]"
                                >
                                  <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                </div>
                              </div>
                            )} */}
                        </div>
                      ) : (
                        ""
                      )}
                      {Fields.type.toLowerCase() === "section" ? (
                        <>
                          <div
                            key={Fields.question_no}
                            className={`w-[100%] ${
                              evaluateCondition(
                                values?.normalFields?.[Fields?.depend_question],
                                Fields.condition,
                                Fields.value
                              ) &&
                              Fields?.depend_question &&
                              values?.normalFields?.[Fields?.depend_question]
                                ? "block"
                                : Fields?.depend_question
                                ? "hidden"
                                : "block"
                            } `}
                            style={{ marginBottom: "40px" }}
                          >
                            <FieldArray name={Fields?.question_no}>
                              {({ push, remove }) => (
                                <>
                                  <div className="w-[100%]">
                                    <div className="p-[20px] w-[100%] border-2 rounded-t-xl flex items-center justify-between">
                                      <HeaderCompo
                                        className="text-xl text-black mt-0 m-0"
                                        tagType="h3"
                                        text={Fields.question}
                                      />
                                      <div className="flex gap-[20px]">
                                        {selectedRows?.[Fields?.question_no]
                                          ?.length > 0 && (
                                          <m.div {...fadeIn}>
                                            <ButtonComp
                                              type="button"
                                              onClick={() =>
                                                deleteSelectedRows(
                                                  remove,
                                                  Fields.question_no
                                                )
                                              }
                                              text="Delete"
                                              className="px-[20px] h-[40px] text-[#004878] border-2 bg-transparent border-[#004878] rounded-full py-[5px]"
                                            />
                                          </m.div>
                                        )}
                                        {/* {!fIlledValues?.[openPopup?.index] ? ( */}
                                        <ButtonComp
                                          type="button"
                                          onClick={() =>
                                            push(
                                              createInitialValues(
                                                Fields.sub_questions
                                              )?.[Fields.question_no][0]
                                            )
                                          }
                                          text="Add"
                                          className="px-[20px] h-[40px] text-white bg-[#004878] rounded-full py-[5px]"
                                        />
                                        {/* ) : (
                                          ""
                                        )} */}
                                      </div>
                                    </div>
                                    <div className="overflow-scroll">
                                      <table className="border-2 text-[#667085] rounded-t-2xl w-[100%]">
                                        <thead>
                                          <tr className="border-b-2">
                                            <th className="p-[10px]">
                                              <div className="w-[20px]">
                                                {values?.[Fields?.question_no]
                                                  ?.length > 0 ? (
                                                  <InputCompo
                                                    type="checkbox"
                                                    className="w-[20px] h-[20px]"
                                                    checked={
                                                      values?.[
                                                        Fields?.question_no
                                                      ]?.length > 0 &&
                                                      selectedRows?.[
                                                        Fields?.question_no
                                                      ]?.length ===
                                                        values?.[
                                                          Fields?.question_no
                                                        ]?.length
                                                    }
                                                    onChange={(e) =>
                                                      toggleAllRows(
                                                        e,
                                                        values,
                                                        Fields?.question_no
                                                      )
                                                    }
                                                  />
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                            </th>
                                            <th className="p-[10px] w-[50px]">
                                              No.
                                            </th>
                                            {Fields.sub_questions.map(
                                              (subQ) => (
                                                <th
                                                  key={subQ.question_no}
                                                  className="p-[10px] min-w-[250px]"
                                                >
                                                  {subQ.question}
                                                </th>
                                              )
                                            )}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {values?.[Fields.question_no]?.map(
                                            (row, rowIndex) => (
                                              <tr
                                                key={rowIndex}
                                                className="border-b-2"
                                              >
                                                <td className="p-[10px]">
                                                  <InputCompo
                                                    className="w-[20px] h-[20px]"
                                                    type="checkbox"
                                                    checked={selectedRows?.[
                                                      Fields?.question_no
                                                    ]?.includes(rowIndex)}
                                                    onChange={() =>
                                                      toggleRowSelection(
                                                        rowIndex,
                                                        Fields.question_no
                                                      )
                                                    }
                                                  />
                                                </td>
                                                <td className="p-[10px] min-w-[50px]">
                                                  {rowIndex + 1}
                                                </td>
                                                {Fields.sub_questions.map(
                                                  (subQ) => (
                                                    <td
                                                      key={subQ.question_no}
                                                      className={`p-[10px] ${
                                                        subQ?.type.toLowerCase() ===
                                                        "checkbox"
                                                          ? "w-[50px]"
                                                          : "min-w-[350px] max-w-[250px]"
                                                      } `}
                                                    >
                                                      {subQ.type ===
                                                      "Dropdown" ? (
                                                        <div className="flex gap-[10px]">
                                                          <CustomSelection
                                                            required={
                                                              subQ?.mandatory >
                                                              0
                                                                ? true
                                                                : false
                                                            }
                                                            imgKey="flag"
                                                            exDataKey={
                                                              subQ?.question ===
                                                              "Country Code"
                                                                ? "label"
                                                                : undefined
                                                            }
                                                            // disabled={
                                                            //   hasAnswerForQuestion(
                                                            //     Fields,
                                                            //     subQ
                                                            //   )
                                                            //     ? true
                                                            //     : subQ?.depend_question
                                                            //     ? !evaluateCondition(
                                                            //         row?.[
                                                            //           subQ
                                                            //             ?.depend_question
                                                            //         ],
                                                            //         subQ.condition,
                                                            //         subQ.value
                                                            //       )
                                                            //     : false
                                                            // }
                                                            mappingKey={
                                                              subQ?.question ===
                                                              "Country Code"
                                                                ? "phone"
                                                                : undefined
                                                            }
                                                            options={
                                                              subQ?.question ===
                                                              "Country Code"
                                                                ? allCountries
                                                                : subQ?.options
                                                            }
                                                            onChange={
                                                              handleChange
                                                            }
                                                            onBlur={handleBlur}
                                                            name={`${Fields?.question_no}.${rowIndex}.${subQ?.question_no}`}
                                                            value={
                                                              row?.[
                                                                subQ.question_no
                                                              ]
                                                            } // Ensure empty string for no value
                                                            label="Select"
                                                            noSort={true}
                                                          />
                                                          {/* {hasAnswerForQuestion(
                                                            Fields,
                                                            subQ
                                                          ) && (
                                                            <div className="flex gap-[10px] mt-[8px]">
                                                              <div
                                                                onClick={() =>
                                                                  OpenModal(
                                                                    "edit",
                                                                    subQ,
                                                                    values,
                                                                    Fields?.type,
                                                                    Fields?.question,
                                                                    rowIndex,
                                                                    Fields?.question_no,
                                                                    Fields?.question
                                                                  )
                                                                }
                                                                className="cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                                              >
                                                                <BorderColorIcon className="text-white" />
                                                              </div>
                                                              <div
                                                                onClick={() =>
                                                                  OpenModal(
                                                                    "comment",
                                                                    subQ,
                                                                    values,
                                                                    Fields?.type,
                                                                    Fields?.question,
                                                                    rowIndex,
                                                                    Fields?.question_no,
                                                                    Fields?.question
                                                                  )
                                                                }
                                                                className="bg-[#004878] h-fit rounded-full p-[8px]"
                                                              >
                                                                <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                              </div>
                                                            </div>
                                                          )} */}
                                                        </div>
                                                      ) : subQ.type.toLowerCase() ===
                                                        "checkbox" ? (
                                                        <InputCompo
                                                          required={
                                                            subQ?.mandatory > 0
                                                          }
                                                          options={
                                                            subQ?.options
                                                          }
                                                          onChange={(e) =>
                                                            setFieldValue(
                                                              `${Fields.question_no}.${rowIndex}.${subQ.question_no}`,
                                                              e.target.checked
                                                                ? "1"
                                                                : "0"
                                                            )
                                                          }
                                                          checked={
                                                            values?.[
                                                              Fields.question_no
                                                            ]?.[rowIndex]?.[
                                                              subQ.question_no
                                                            ] === "1"
                                                          }
                                                          name={`${Fields.question_no}.${rowIndex}.${subQ.question_no}`}
                                                          className="bg-[#004878] text-white w-[20px] h-[20px]"
                                                          type="checkbox"
                                                        />
                                                      ) : subQ.type ===
                                                          "Text" ||
                                                        subQ.type === "Float" ||
                                                        subQ.type ===
                                                          "Number" ||
                                                        subQ.type === "Date" ? (
                                                        <div className="flex gap-[10px]">
                                                          <CustomInput
                                                            required={
                                                              subQ?.mandatory >
                                                              0
                                                                ? true
                                                                : false
                                                            }
                                                            error={
                                                              subQ.validation.toLowerCase() ===
                                                                "email" &&
                                                              Boolean(
                                                                emailErrors[
                                                                  rowIndex
                                                                ]
                                                              )
                                                            }
                                                            helperText={
                                                              subQ.validation.toLowerCase() ===
                                                              "email"
                                                                ? emailErrors[
                                                                    rowIndex
                                                                  ]
                                                                : ""
                                                            }
                                                            // disabled={
                                                            //   hasAnswerForQuestion(
                                                            //     Fields,
                                                            //     subQ
                                                            //   )
                                                            //     ? true
                                                            //     : subQ?.depend_question
                                                            //     ? !evaluateCondition(
                                                            //         row?.[
                                                            //           subQ
                                                            //             ?.depend_question
                                                            //         ],
                                                            //         subQ.condition,
                                                            //         subQ.value
                                                            //       )
                                                            //       ? true
                                                            //       : false
                                                            //     : ""
                                                            // }
                                                            options={
                                                              subQ?.options
                                                            }
                                                            type={
                                                              subQ.type.toLowerCase() ===
                                                              "float"
                                                                ? "number"
                                                                : subQ.validation.toLowerCase() ===
                                                                  "email"
                                                                ? "email"
                                                                : subQ.type.toLowerCase()
                                                            }
                                                            onChange={(e) => {
                                                              let value =
                                                                e.target.value;

                                                              if (
                                                                subQ.type.toLowerCase() ===
                                                                "float"
                                                              ) {
                                                                const decimalIndex =
                                                                  value.indexOf(
                                                                    "."
                                                                  );
                                                                if (
                                                                  decimalIndex !==
                                                                  -1
                                                                ) {
                                                                  const decimalPart =
                                                                    value.substring(
                                                                      decimalIndex +
                                                                        1
                                                                    );
                                                                  if (
                                                                    decimalPart.length >
                                                                    2
                                                                  ) {
                                                                    enqueueSnackbar(
                                                                      `${subQ?.question} can only have up to 2 decimal places`,
                                                                      {
                                                                        variant:
                                                                          "warning",
                                                                      }
                                                                    );
                                                                    value =
                                                                      value.substring(
                                                                        0,
                                                                        decimalIndex +
                                                                          3
                                                                      );
                                                                  }
                                                                }
                                                              }

                                                              if (
                                                                subQ.validation.toLowerCase() ===
                                                                "email"
                                                              ) {
                                                                const emailPattern =
                                                                  /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                                                if (
                                                                  value &&
                                                                  !emailPattern.test(
                                                                    value
                                                                  )
                                                                ) {
                                                                  setEmailErrors(
                                                                    (prev) => ({
                                                                      ...prev,
                                                                      [rowIndex]:
                                                                        "Please enter a valid email address",
                                                                    })
                                                                  );
                                                                } else {
                                                                  setEmailErrors(
                                                                    (prev) => ({
                                                                      ...prev,
                                                                      [rowIndex]:
                                                                        "",
                                                                    })
                                                                  );
                                                                }
                                                              }
                                                              e.target.value =
                                                                value;
                                                              handleChange(e);
                                                            }}
                                                            onBlur={handleBlur}
                                                            name={`${Fields?.question_no}.${rowIndex}.${subQ.question_no}`}
                                                            value={
                                                              row[
                                                                subQ.question_no
                                                              ]
                                                            }
                                                            label={
                                                              subQ.question ===
                                                              "Telephone Number"
                                                                ? "Enter the number here"
                                                                : "Enter"
                                                            }
                                                          />
                                                          {/* {hasAnswerForQuestion(
                                                            Fields,
                                                            subQ
                                                          ) && (
                                                            <div className="flex gap-[10px] mt-[8px]">
                                                              <div
                                                                onClick={() =>
                                                                  OpenModal(
                                                                    "edit",
                                                                    subQ,
                                                                    values,
                                                                    Fields?.type,
                                                                    Fields?.question,
                                                                    rowIndex,
                                                                    Fields?.question_no,
                                                                    Fields?.question
                                                                  )
                                                                }
                                                                className="cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                                              >
                                                                <BorderColorIcon className="text-white" />
                                                              </div>
                                                              <div
                                                                onClick={() =>
                                                                  OpenModal(
                                                                    "comment",
                                                                    subQ,
                                                                    values,
                                                                    Fields?.type,
                                                                    Fields?.question,
                                                                    rowIndex,
                                                                    Fields?.question_no,
                                                                    Fields?.question
                                                                  )
                                                                }
                                                                className="bg-[#004878] h-fit rounded-full p-[8px]"
                                                              >
                                                                <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                              </div>
                                                            </div>
                                                          )} */}
                                                        </div>
                                                      ) : subQ.type.toLowerCase() ===
                                                        "attach" ? (
                                                        <CustomFileInput
                                                          // disabled={
                                                          //   hasAnswerForQuestion(
                                                          //     Fields,
                                                          //     subQ
                                                          //   )
                                                          //     ? true
                                                          //     : false
                                                          // }
                                                          required={
                                                            subQ?.mandatory > 0
                                                              ? true
                                                              : false
                                                          }
                                                          onChange={(e) =>
                                                            attachFile(
                                                              e,
                                                              setFieldValue
                                                            )
                                                          }
                                                          name={`${Fields?.question_no}.${rowIndex}.${subQ.question_no}`}
                                                          value={
                                                            row[
                                                              subQ.question_no
                                                            ].file_name
                                                          }
                                                          file={
                                                            row[
                                                              subQ.question_no
                                                            ].attach_file
                                                          }
                                                          label={subQ.question}
                                                        />
                                                      ) : subQ.type.toLowerCase() ===
                                                        "multiselect dropdown" ? (
                                                        <div className="flex gap-[10px]">
                                                          <MultipleSelect
                                                            // disabled={
                                                            //   hasAnswerForQuestion(
                                                            //     Fields,
                                                            //     subQ
                                                            //   )
                                                            //     ? true
                                                            //     : false
                                                            // }
                                                            maxSelect={
                                                              Fields.validation ===
                                                                "Select Upto 3" &&
                                                              3
                                                            }
                                                            required={
                                                              subQ?.mandatory >
                                                                0 ||
                                                              evaluateCondition(
                                                                row?.[
                                                                  subQ
                                                                    ?.depend_question
                                                                ],
                                                                subQ.condition,
                                                                subQ.value
                                                              )
                                                            }
                                                            onValueChange={(
                                                              name,
                                                              values
                                                            ) =>
                                                              multiSelectedValues(
                                                                name,
                                                                Fields.question_no,
                                                                values,
                                                                setFieldValue
                                                              )
                                                            }
                                                            options={
                                                              subQ?.options
                                                            }
                                                            mappingKey="option"
                                                            selectedValues={
                                                              row[
                                                                subQ
                                                                  ?.question_no
                                                              ]
                                                            }
                                                            name={`${Fields?.question_no}.${rowIndex}.${subQ?.question_no}`}
                                                            label={
                                                              subQ?.question
                                                            }
                                                          />
                                                          {/* {hasAnswerForQuestion(
                                                            Fields,
                                                            subQ
                                                          ) && (
                                                            <div className="flex gap-[10px] mt-[8px]">
                                                              <div
                                                                onClick={() =>
                                                                  OpenModal(
                                                                    "edit",
                                                                    subQ,
                                                                    values,
                                                                    Fields?.type,
                                                                    Fields?.question,
                                                                    rowIndex,
                                                                    Fields?.question_no,
                                                                    Fields?.question
                                                                  )
                                                                }
                                                                className="cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                                              >
                                                                <BorderColorIcon className="text-white" />
                                                              </div>
                                                              <div
                                                                onClick={() =>
                                                                  OpenModal(
                                                                    "comment",
                                                                    subQ,
                                                                    values,
                                                                    Fields?.type,
                                                                    Fields?.question,
                                                                    rowIndex,
                                                                    Fields?.question_no,
                                                                    Fields?.question
                                                                  )
                                                                }
                                                                className="bg-[#004878] h-fit rounded-full p-[8px]"
                                                              >
                                                                <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                              </div>
                                                            </div>
                                                          )} */}
                                                        </div>
                                                      ) : (
                                                        ""
                                                      )}

                                                      {errors?.[
                                                        Fields.question_no
                                                      ]?.[rowIndex][
                                                        subQ.question_no
                                                      ] &&
                                                        row[
                                                          subQ.question_no
                                                        ] && (
                                                          <div className="error">
                                                            {
                                                              errors?.[
                                                                Fields
                                                                  .question_no
                                                              ][rowIndex][
                                                                subQ.question_no
                                                              ]
                                                            }
                                                          </div>
                                                        )}
                                                    </td>
                                                  )
                                                )}
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </>
                              )}
                            </FieldArray>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  ))}
                  <DisplayFormikValues />
                </div>
                {/* {!fIlledValues?.[openPopup?.index] ? ( */}
                <div className="flex justify-end">
                  <ButtonComp
                    type="submit"
                    className="px-[20px] py-[6px] h-[40px] text-white bg-[#004878] rounded-full"
                    text="Save & Next"
                  />
                </div>
                {/* ) : (
                  ""
                )} */}
                <ModalComp
                  width={"35%"}
                  modalIsOpen={isModalOpen?.["comment"]}
                  closeModal={CloseModal}
                >
                  <HeaderCompo
                    className="text-2xl mb-[10px] font-bold text-black mt-[10px] text-center"
                    tagType={"h3"}
                    text="Comment"
                  />
                  <ParagraphComp className="text-lg text-black text-center">
                    {isModalOpen?.type?.toLowerCase() === "section"
                      ? (questions?.docs_answers?.length > 0 &&
                          Array.isArray(
                            questions?.docs_answers?.[
                              openPopup?.index
                            ]?.d_answers?.find(
                              (doc) => doc?.question === isModalOpen?.question
                            )?.answer
                          ) &&
                          questions?.docs_answers?.[openPopup?.index]?.d_answers
                            ?.find(
                              (doc) => doc?.question === isModalOpen?.question
                            )
                            ?.answer?.[isModalOpen?.index]?.find(
                              (ans) =>
                                ans.question_no ===
                                isModalOpen?.data?.question_no
                            )?.comments_for_npo) ||
                        "No comment was added by the administrator"
                      : (questions?.docs_answers?.[openPopup?.index]?.d_answers
                          ?.length > 0 &&
                          questions?.docs_answers?.[
                            openPopup?.index
                          ]?.d_answers?.find(
                            (doc) =>
                              doc?.question_no ===
                              isModalOpen?.data?.question_no
                          )?.comments_for_npo) ||
                        "No comment was added by the administrator."}
                  </ParagraphComp>
                  <div className="flex justify-end">
                    <ButtonComp
                      onClick={CloseModal}
                      type="button"
                      className=" mt-[10px] py-[5px] px-[10px] rounded-[20px] border-2 border-[#004878] text-[#004878]"
                    >
                      Close
                    </ButtonComp>
                  </div>
                </ModalComp>
                <ModalComp
                  width={"35%"}
                  modalIsOpen={isModalOpen?.["edit"]}
                  closeModal={CloseModal}
                >
                  <Formik
                    initialValues={{
                      [isModalOpen?.data?.question_no || "default_question_no"]:
                        "",
                    }}
                    validationSchema={editModalSchema}
                    onSubmit={(values) => {
                      updateValues(values, setFieldValue);
                    }}
                  >
                    {({
                      values: modalValues,
                      errors: modalErrors,
                      handleChange,
                      setFieldValue: setModalFieldValue,
                    }) => (
                      <Form>
                        <div className="h-auto">
                          {/* Close Button */}
                          <div className="flex justify-end">
                            <div
                              className="cursor-pointer"
                              onClick={CloseModal}
                            >
                              <CloseIcon />
                            </div>
                          </div>

                          {/* Header */}
                          <HeaderCompo
                            className="text-2xl mb-[10px] font-bold text-black mt-[10px] text-center"
                            tagType="h3"
                            text="Edit"
                          />
                          <ParagraphComp
                            className="text-lg text-black text-start"
                            text="Question"
                          />
                          <ParagraphComp
                            className="text-md mt-[10px] text-[#3f3f3f] text-start"
                            text={isModalOpen?.data?.question}
                          />
                          {(
                            isModalOpen?.type?.toLowerCase() === "section"
                              ? values?.[isModalOpen?.question]?.[
                                  isModalOpen?.index
                                ]?.[isModalOpen?.data?.question_no] ||
                                (questions?.docs_answers?.length > 0 &&
                                  Array.isArray(
                                    questions?.docs_answers?.[
                                      openPopup?.index
                                    ]?.d_answers?.find(
                                      (doc) =>
                                        doc?.question === isModalOpen?.question
                                    ).answer
                                  ) &&
                                  questions?.docs_answers?.[
                                    openPopup?.index
                                  ]?.d_answers
                                    ?.find(
                                      (doc) =>
                                        doc?.question === isModalOpen?.question
                                    )
                                    .answer?.find(
                                      (ele) =>
                                        ele?.question_no ===
                                        isModalOpen?.data?.question_no
                                    )) ||
                                ""
                              : isModalOpen?.data?.type === "Attach" &&
                                questions?.docs_answers?.length > 0
                              ? {
                                  file_name:
                                    questions?.docs_answers?.[
                                      openPopup?.index
                                    ]?.d_answers?.find(
                                      (doc) =>
                                        doc?.question_no ===
                                        isModalOpen?.data?.question_no
                                    )?.upload_document || "",
                                }
                              : isModalOpen?.data?.type ===
                                  "Multiselect Dropdown" &&
                                questions?.docs_answers?.length > 0
                              ? questions?.docs_answers?.[
                                  openPopup?.index
                                ]?.d_answers
                                  ?.find(
                                    (doc) =>
                                      doc?.question_no ===
                                      isModalOpen?.data?.question_no
                                  )
                                  ?.answer?.split(",")
                              : values?.[isModalOpen?.data?.question_no] ||
                                (questions?.docs_answers?.length > 0 &&
                                  questions?.docs_answers?.[
                                    openPopup?.index
                                  ]?.d_answers?.find(
                                    (doc) =>
                                      doc?.question_no ===
                                      isModalOpen?.data?.question_no
                                  )?.answer)
                          ) ? (
                            <ParagraphComp
                              className="text-lg mt-[10px] text-black text-start"
                              text="Current Answer"
                            />
                          ) : (
                            ""
                          )}
                          <ParagraphComp className="text-md mt-[10px] text-[#3f3f3f] text-start">
                            {isModalOpen?.type?.toLowerCase() === "section"
                              ? (() => {
                                  // Find the section d_answer object
                                  const sectionAnswerObj =
                                    questions?.docs_answers?.[
                                      openPopup.index
                                    ]?.d_answers?.find(
                                      (doc) =>
                                        doc?.question === isModalOpen?.question
                                    );
                                  if (
                                    sectionAnswerObj &&
                                    Array.isArray(sectionAnswerObj.answer)
                                  ) {
                                    // If rowIndex is available in isModalOpen, use it, else show all rows
                                    if (
                                      typeof isModalOpen?.rowIndex === "number"
                                    ) {
                                      const row =
                                        sectionAnswerObj.answer[
                                          isModalOpen.rowIndex
                                        ];
                                      if (Array.isArray(row)) {
                                        const subQ = row.find(
                                          (ans) =>
                                            ans.question_no ===
                                            isModalOpen?.data?.question_no
                                        );
                                        return subQ?.answer || "";
                                      }
                                    } else {
                                      // Show all rows for this sub-question
                                      return sectionAnswerObj.answer
                                        .map((row, idx) => {
                                          const subQ = row.find(
                                            (ans) =>
                                              ans.question_no ===
                                              isModalOpen?.data?.question_no
                                          );
                                          return subQ
                                            ? `Row ${idx + 1}: ${subQ.answer}`
                                            : null;
                                        })
                                        .filter(Boolean)
                                        .join(", ");
                                    }
                                  }
                                  return "";
                                })()
                              : isModalOpen?.data?.type === "Attach" &&
                                questions?.docs_answers?.length > 0
                              ? {
                                  file_name:
                                    questions?.docs_answers?.[
                                      openPopup?.index
                                    ]?.d_answers?.find(
                                      (doc) =>
                                        doc?.question_no ===
                                        isModalOpen?.data?.question_no
                                    )?.upload_document || "",
                                }
                              : isModalOpen?.data?.type ===
                                  "Multiselect Dropdown" &&
                                questions?.docs_answers?.length > 0
                              ? questions?.docs_answers?.[
                                  openPopup?.index
                                ]?.d_answers
                                  ?.find(
                                    (doc) =>
                                      doc?.question_no ===
                                      isModalOpen?.data?.question_no
                                  )
                                  ?.answer?.split(",")
                              : values?.[isModalOpen?.data?.question_no] ||
                                (questions?.docs_answers?.length > 0 &&
                                  questions?.docs_answers?.[
                                    openPopup?.index
                                  ]?.d_answers?.find(
                                    (doc) =>
                                      doc?.question_no ===
                                      isModalOpen?.data?.question_no
                                  )?.answer) ||
                                ""}
                          </ParagraphComp>

                          {/* Input Types Handling */}
                          {["text", "number", "date", "password"].includes(
                            isModalOpen?.data?.type.toLowerCase()
                          ) && (
                            <div className="mt-[20px]">
                              <CustomInput
                                required
                                type={isModalOpen?.data?.type?.toLowerCase()}
                                name={isModalOpen?.data?.question_no}
                                value={
                                  modalValues?.[isModalOpen?.data?.question_no]
                                }
                                onChange={handleChange}
                                label="New Answer"
                              />
                              <ParagraphComp
                                className="text-[red] text-[10px] px-[8px] mt-1"
                                text={
                                  modalErrors?.[isModalOpen?.data?.question_no]
                                }
                              />
                            </div>
                          )}

                          {isModalOpen?.data?.type.toLowerCase() ===
                            "dropdown" && (
                            <div className="mt-[20px]">
                              <CustomSelection
                                imgKey="flag"
                                exDataKey={
                                  isModalOpen?.data?.question === "Country Code"
                                    ? "label"
                                    : undefined
                                }
                                mappingKey={
                                  isModalOpen?.data?.question === "Country Code"
                                    ? "phone"
                                    : undefined
                                }
                                options={
                                  isModalOpen?.data?.question === "Country Code"
                                    ? allCountries
                                    : isModalOpen?.data?.options
                                }
                                required
                                value={
                                  modalValues?.[isModalOpen?.data?.question_no]
                                }
                                onChange={handleChange}
                                name={isModalOpen?.data?.question_no}
                                label="New Answer"
                              />
                              <ParagraphComp
                                className="text-[red] text-[10px] px-[8px] mt-1"
                                text={
                                  modalErrors?.[isModalOpen?.data?.question_no]
                                }
                              />
                            </div>
                          )}

                          {isModalOpen?.data?.type.toLowerCase() ===
                            "multiselect dropdown" && (
                            <div className="mt-[20px]">
                              <MultipleSelect
                                required
                                options={(() => {
                                  const baseOptions =
                                    isModalOpen?.data?.options || [];
                                  return isModalOpen?.data?.question_no ===
                                    "DRQ-00077"
                                    ? baseOptions.filter((ele) =>
                                        values?.["DRQ-00076"]?.includes(
                                          ele.value
                                        )
                                      )
                                    : [
                                        ...new Map(
                                          baseOptions.map((item) => [
                                            item.value,
                                            item,
                                          ])
                                        ).values(),
                                      ]; // Ensuring unique keys
                                })()}
                                maxSelect={
                                  isModalOpen?.data?.validation ===
                                  "Select Upto 3"
                                    ? 3
                                    : undefined
                                }
                                mappingKey="option"
                                onValueChange={(name, values) =>
                                  modalMultiSelectedValues(
                                    name,
                                    values,
                                    setModalFieldValue
                                  )
                                }
                                selectedValues={
                                  modalValues?.[
                                    isModalOpen?.data?.question_no
                                  ] || []
                                }
                                name={isModalOpen?.data?.question_no}
                                label="New Answer"
                              />
                              <ParagraphComp
                                className="text-[red] text-[10px] px-[8px] mt-1"
                                text={
                                  modalErrors?.[isModalOpen?.data?.question_no]
                                }
                              />
                            </div>
                          )}

                          {isModalOpen?.data?.type?.toLowerCase() ===
                            "text area" && (
                            <div className="mt-[20px]">
                              <CustomTextarea
                                required={true}
                                name={isModalOpen?.data?.question_no}
                                value={
                                  modalValues?.[isModalOpen?.data?.question_no]
                                }
                                onChange={handleChange}
                                label="New Answer"
                              />
                              <ParagraphComp
                                className="text-[red] text-[10px] px-[8px] mt-1"
                                text={
                                  modalValues?.[
                                    isModalOpen?.data?.question_no
                                  ] &&
                                  modalErrors?.[isModalOpen?.data?.question_no]
                                }
                              />
                            </div>
                          )}
                          {isModalOpen?.data?.type.toLowerCase() ===
                            "attach" && (
                            <div className="mt-[20px]">
                              <CustomFileInput
                                required
                                onChange={(e) =>
                                  attachFile(e, setModalFieldValue)
                                }
                                value={
                                  modalValues?.[isModalOpen?.data?.question_no]
                                    ?.file_name
                                }
                                name={isModalOpen?.data?.question_no}
                                label="New Answer"
                              />
                              <ParagraphComp
                                className="text-[red] text-[10px] px-[8px] mt-1"
                                text={
                                  modalErrors?.[isModalOpen?.data?.question_no]
                                }
                              />
                            </div>
                          )}

                          {/* Save Button */}
                          <div className="flex justify-center mt-[15px]">
                            <ButtonComp
                              disabled={editLoading}
                              className="w-[150px] rounded-full bg-[#004878] p-[6px] text-white border-none"
                              type="Submit"
                              text={editLoading ? "Saving..." : "Save"}
                            />
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </ModalComp>
              </Form>
            )}
          </Formik>
        </div>
      </ModalComp>
    </>
  );
};

export default Undertaking2;
